module.exports = __webpack_public_path__ + "static/media/splash.571f3f0b.png";